import { useState } from 'react';

import { getDoctorChatTicketLabel } from 'src/helpers';
import constants from 'src/constants';
import {
  getAvailableDayHandler,
  getExperienceLabel,
  getHospitalLabel
} from './doctorDetailUtils';

/**
 * All shared logic for the doctor detail page (desktop + mobile).
 * Layout components only render what this hook returns.
 */
export const useDoctorDetail = ({ doctor, locations = [], slotsMonth = [] }) => {
  const [selectedId, setSelectedId] = useState(locations[0]?.id ?? null);

  // Fall back to the first location if the selected one is gone
  const selectedLocation = locations.find((l) => l.id === selectedId) || locations[0] || null;

  const currency = doctor.currency || constants.general.defaultCurrency;

  return {
    currency,
    experience: getExperienceLabel(doctor),
    chatTicketLabel: getDoctorChatTicketLabel(doctor.charge?.chatTicket, currency),
    hospitalAddress: [getHospitalLabel(doctor.hospitalName), doctor.hospitalAddress]
      .filter(Boolean)
      .join(', '),
    locations,
    selectedLocation,
    selectLocation: (location) => setSelectedId(location?.id ?? null),
    onClassNamesOfCell: getAvailableDayHandler(slotsMonth)
  };
};
